module.exports = __webpack_public_path__ + "static/Bangladesh-logo-bde88a44557508f44c2c3a444113e531.png";